// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ZLjp6","prev":"style_prev__pgCCC","next":"style_next__3iV7f","active":"style_active__Km_5e","dots":"style_dots__5X__l"};